var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyCareTeamWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 4.78179H15.75V3.43049H14.25V2.07919H12.75V3.43049H11.25V4.78179H12.75V6.13309H14.25V4.78179Z",
    fill: "#FDFDFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8 0.0522461H16.2C17.19 0.0522461 18 0.781947 18 1.6738V11.4032C18 12.295 17.19 13.0247 16.2 13.0247H3.6L0 16.2678V1.6738C0 0.781947 0.81 0.0522461 1.8 0.0522461ZM10.875 1.06572H16.125C16.5375 1.06572 16.875 1.36976 16.875 1.74137V6.47091C16.875 6.84252 16.5375 7.14656 16.125 7.14656H10.875C10.4625 7.14656 10.125 6.84252 10.125 6.47091L10.1287 1.74137C10.1287 1.36976 10.4625 1.06572 10.875 1.06572Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCareTeamWhite);
export default __webpack_public_path__ + "static/media/my_care_team_white.cc458a4cdd5862ac8879ce9d184f793b.svg";
export { ForwardRef as ReactComponent };